<template>
  <div class="category_container" ref="chartRef"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "category_container",
  props: {
    themeData: {
      type: Object,
      default: null,
    },
    cateWidth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      myChart: null,
      resizeObserver: null,
      datax: [],
      datay1: [],
      datay2: [],
      datay3: [],
      datay4: [],
    };
  },
  watch: {
    themeData: {
      handler(val) {
        if (val && val.yearList && val.conceptTrendTypeBoList) {
          this.datax = val.yearList;
          this.datay1 = val.conceptTrendTypeBoList[0]?.countList || [];
          this.datay2 = val.conceptTrendTypeBoList[1]?.countList || [];
          this.datay3 = val.conceptTrendTypeBoList[2]?.countList || [];
          this.datay4 = val.conceptTrendTypeBoList[3]?.countList || [];
          this.$nextTick(() => {
            this.renderChart();
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
      this.renderChart();
    });
    window.addEventListener("resize", this.handleResize);
    if (typeof ResizeObserver !== "undefined" && this.$refs.chartRef) {
      this.resizeObserver = new ResizeObserver(this.handleResize);
      this.resizeObserver.observe(this.$refs.chartRef);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    if (this.myChart) {
      this.myChart.dispose();
      this.myChart = null;
    }
  },
  methods: {
    handleResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    },
    initChart() {
      const chartDom = this.$refs.chartRef;
      if (!chartDom) {
        return;
      }
      this.myChart = echarts.init(chartDom);
    },
    renderChart() {
      if (!this.myChart) {
        this.initChart();
      }
      if (!this.myChart) {
        return;
      }
      if (!this.datax || this.datax.length === 0) {
        return;
      }

      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["论文", "作者", "机构", "期刊"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.datax,
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "论文",
            data: this.datay1,
            type: "line",
            lineStyle: {
              color: "#87CEEB",
            },
            itemStyle: {
              color: "#87CEEB",
            },
            smooth: true,
          },
          {
            name: "作者",
            type: "line",
            data: this.datay2,
            smooth: true,
          },
          {
            name: "机构",
            type: "line",
            data: this.datay3,
            smooth: true,
          },
          {
            name: "期刊",
            type: "line",
            data: this.datay4,
            smooth: true,
          },
        ],
      };
      this.myChart.setOption(option, true);

      this.myChart.off("click");
      this.myChart.on("click", params => {
        if (params.componentType === "series") {
          this.$emit("category-event", params);
        }
      });
    },
  },
};
</script>
<style lang="scss" scope>
.category_container {
  height: 340px;
  width: 100%;
}
</style>
